<template>
  <NuxtLayout>
    <section
      class="bp-wrap bp-error"
      aria-labelledby="error-title"
    >
      <div class="bp-error__code">
        <span class="bp-h2__ref">Sheet</span>
        <h1 class="bp-display">
          {{ statusCode }}
        </h1>
      </div>
      <h2
        id="error-title"
        class="bp-error__title"
      >
        {{ errorTitle }}
      </h2>
      <p class="bp-body">
        {{ errorMessage }}
      </p>
      <div class="bp-error__actions">
        <NuxtLink
          to="/"
          class="bp-btn bp-btn--signal"
        >
          Back to the drawing
          <BlueprintArrow />
        </NuxtLink>
        <button
          v-if="statusCode !== 404"
          type="button"
          class="bp-btn"
          @click="handleError"
        >
          Try again
          <BlueprintArrow />
        </button>
      </div>
      <details
        v-if="isDev && error?.stack"
        class="bp-error__details"
      >
        <summary class="bp-label">
          Error details (development only)
        </summary>
        <pre><code>{{ error.stack }}</code></pre>
      </details>
    </section>
  </NuxtLayout>
</template>

<script setup lang="ts">
const props = defineProps({
  error: {
    type: Object,
    required: true
  }
})

const isDev = computed(() => import.meta.dev)

const statusCode = computed(() => props.error?.statusCode || 500)

const errorTitle = computed(() => {
  switch (statusCode.value) {
    case 404:
      return 'Page Not Found'
    case 500:
      return 'Internal Server Error'
    case 503:
      return 'Service Unavailable'
    default:
      return 'Something Went Wrong'
  }
})

const errorMessage = computed(() => {
  switch (statusCode.value) {
    case 404:
      return 'The page you\'re looking for doesn\'t exist or has been moved.'
    case 500:
      return 'We\'re experiencing technical difficulties. Our team has been notified and is working on it.'
    case 503:
      return 'The service is temporarily unavailable. Please try again in a few moments.'
    default:
      return (
        props.error?.message
        || 'An unexpected error occurred. Please try again later.'
      )
  }
})

const handleError = () => clearError({ redirect: '/' })

useHead({
  title: `${statusCode.value} - ${errorTitle.value}`
})
</script>
